import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { onCheckListRolePresence } from '@/app/utils/onCheckListRolePresence'
import { adminsState, authState } from '@App/store'
import { type IUpdateAdminDto, type INewAdminDto, type IPriceDto, type IFedOrderDto } from '@App/types/adminsTypes'
import { ROLE_MAPPER, routes } from '@Config/config'

import { AdminControl } from './AdminControl/AdminControl'
import style from './Admins.module.scss'
import { AdminsList } from './AdminsList/AdminsList'
import { PriceErrors } from './PriceErrors/PriceErrors'

export const Admins = observer(() => {
    const navigate = useNavigate()

    useEffect(() => {
        // if (authState.userData?.roles === ROLE_MAPPER.RADMN) {
        if (authState.userData?.roles && onCheckListRolePresence(authState.userData.roles, [ROLE_MAPPER.RADMN])) {
            navigate(routes.FAQS)
        }
    }, [navigate])

    const [showUpdatePriceModal, setShowUpdatePriceModal] = useState<boolean>(false)
    const [showUpdateOrderModal, setShowUpdateOrderModal] = useState<boolean>(false)
    const [showAddAdmin, setShowAddAdmin] = useState<boolean>(false)
    const [removableAdmin, setRemovableAdmin] = useState<string | null>(null)

    const onGetPageItemsQuantity = (quantity: number) => {
        const cases = [2, 0, 1, 1, 1, 2]
        const titles = ['специалист', 'специалиста', 'специалистов']

        if (quantity % 100 > 4 && quantity % 100 < 20) {
            return `${quantity} ${titles[2]}`
        } else {
            return `${quantity} ${titles[cases[Math.min(quantity % 10, 5)]]}`
        }
    }

    const pageInfo = onGetPageItemsQuantity(adminsState?.admins?.length || 0)

    const onGetAdminsListCallBack = useCallback(() => {
        if (!adminsState.admins) {
            adminsState.onGetAdmins()
        }
        return () => {
            adminsState.onSetAdmins(null)
        }
    }, [])

    const onGetPriceActivateDates = useCallback(() => {
        adminsState.onGetPriceActivateDates()
    }, [])

    const updateAdmin = useCallback((dto: IUpdateAdminDto) => {
        adminsState.onUpdateAdmin(dto)
    }, [])

    const addAdmin = useCallback((dto: INewAdminDto) => {
        adminsState.onAddAdmin(dto)
    }, [])

    const removeAdmin = useCallback((adminId: string) => {
        adminsState.onRemoveAdmin(adminId)
    }, [])

    const uploadFileCallback = useCallback((dto: IPriceDto) => {
        adminsState.onUploadPriceFileCallback(dto, () => setShowUpdatePriceModal(false))
    }, [])

    const getPriceDataByDate = useCallback((date: string) => {
        adminsState.onGetPriceDataByDate(date)
    }, [])

    const uploadOrderFileCallback = useCallback((dto: IFedOrderDto) => {
        adminsState.onUploadOrderFileCallback(dto, () => setShowUpdateOrderModal(false))
    }, [])

    useEffect(onGetAdminsListCallBack, [onGetAdminsListCallBack])

    return (
        <div className={style.container}>
            <PriceErrors priceErrors={adminsState.priceErrors} onSetPriceErrors={adminsState.onSetPriceErrors} />
            <AdminControl
                pageInfo={pageInfo}
                showAddAdmin={showAddAdmin}
                activateDates={adminsState.activateDates}
                showUpdatePriceModal={showUpdatePriceModal}
                showUpdateOrderModal={showUpdateOrderModal}
                isFetchingAdmins={adminsState.isFetchingAdmins}
                onChangeDocument={adminsState.onChangeDocument}
                setShowAddAdmin={setShowAddAdmin}
                onAddAdminCallback={addAdmin}
                onUploadFileCallback={uploadFileCallback}
                onUploadOrderFileCallback={uploadOrderFileCallback}
                setShowUpdateOrderModal={setShowUpdateOrderModal}
                setShowUpdatePriceModal={setShowUpdatePriceModal}
                onGetPriceActivateDates={onGetPriceActivateDates}
                onGetPriceDataByDate={getPriceDataByDate}
            />
            <AdminsList
                list={adminsState.admins}
                onUpdateAdminCallback={updateAdmin}
                removableAdmin={removableAdmin}
                setRemovableAdmin={setRemovableAdmin}
                onRemoveAdmin={removeAdmin}
                onAddAdminRole={adminsState.onAddAdminRole}
                onRemoveAdminRole={adminsState.onRemoveAdminRole}
                isFetchingAdmins={adminsState.isFetchingAdmins}
            />
        </div>
    )
})
